import { BaseRepository } from './BaseRepository';

export class KaizenLabServiceRepository extends BaseRepository {
  public getKaizenLabServiceOfOrganizatoin(organizationId: string): Promise<any[]> {
    return this.httpClient
      .get(`/v2/services`, {
        params: { organization_id: organizationId },
      })
      .then((res: any) => res.data.data);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/repository/KaizenLabServiceRepository.ts